import { createSelector } from 'reselect';

const selectCandidates = (state: any) => state.candidates;


export const selectCandidatesCurrentItem = createSelector([selectCandidates], (candidates) => candidates.current);

export const selectCandidatesListItems = createSelector([selectCandidates], (candidates) => candidates.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectCandidatesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectCandidatesCreatedItem = createSelector([selectCandidates], (candidates) => candidates.create);

export const selectCandidatesUpdatedItem = createSelector([selectCandidates], (candidates) => candidates.update);

export const selectCandidatesReadItem = createSelector([selectCandidates], (candidates) => candidates.read);

export const selectCandidatesDeletedItem = createSelector([selectCandidates], (candidates) => candidates.delete);

export const selectCandidatesSearchedItems = createSelector([selectCandidates], (candidates) => candidates.search);

export const selectCandidatesItemsCount = createSelector([selectCandidates], (candidates) => candidates.count);

export const selectCandidatesItemsFilter = createSelector([selectCandidates], (candidates) => candidates.filter);